interface IAlphaAllowListIconProps {
  className?: string;
}

/**
 * Clipboard with three checked list items — the operator metaphor for the
 * tool is "the bouncer's approved list", so the icon shows a clipboard of
 * checks. Monoline, `currentColor`, no fills. Designed on a 48×48 grid; the
 * geometry survives scale-down to the tile's ~48px and up to the page.
 */
const AlphaAllowListIcon = ({ className }: IAlphaAllowListIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* clipboard body */}
    <rect x="9" y="10" width="30" height="32" rx="2" />
    {/* clipboard clip, overlapping the top edge */}
    <rect x="18" y="6" width="12" height="6" rx="1" />
    {/* three approved list rows: check + rule */}
    <path d="M15 22 l2.5 2.5 l5 -5" />
    <path d="M26 22 h9" strokeLinecap="square" />
    <path d="M15 30 l2.5 2.5 l5 -5" />
    <path d="M26 30 h9" strokeLinecap="square" />
    <path d="M15 38 l2.5 2.5 l5 -5" />
    <path d="M26 38 h6" strokeLinecap="square" />
  </svg>
);

export default AlphaAllowListIcon;
